/* eslint-disable no-console */
import { register } from 'register-service-worker'
console.log('----service-worker-----')

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: { scope: './' },
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('[registered] Service worker has been registered.')
    },
    cached () {
      console.log('[cached] Content has been cached for offline use.')
    },
    updatefound () {
      console.log('[updatefound] New content is downloading.')
    },
    updated (registration) {
      console.log('[updated] New content is available; please refresh.')
      registration.unregister().then(function (isUnregistered) {
        if (isUnregistered) {
          window.location.reload()
        } else {
          // send an error message to the frontend-monitor service
          console.error('registration failed')
        }
      }).catch(function (error) {
        // send an error message to the frontend-monitor service
        console.error('Registration failed with ' + error)
      })
    },
    offline () {
      console.log('[offline] No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('[error] Error during service worker registration:', error)
    }
  })
}
